export default "__VITE_ASSET__129de23f__"